var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4653 18H5.34653C2.39846 18 0 15.6015 0 12.6535V5.34653C0 2.39846 2.39846 0 5.34653 0H17.4653C20.4134 0 22.8119 2.39846 22.8119 5.34653V12.6535C22.8119 15.6015 20.4134 18 17.4653 18ZM5.34653 1.78218C3.38115 1.78218 1.78218 3.38115 1.78218 5.34653V12.6535C1.78218 14.6189 3.38115 16.2178 5.34653 16.2178H17.4653C19.4307 16.2178 21.0297 14.6189 21.0297 12.6535V5.34653C21.0297 3.38115 19.4307 1.78218 17.4653 1.78218H5.34653ZM14.6712 10.5775L19.0756 7.2131C19.4667 6.91436 19.5415 6.35516 19.2428 5.96406C18.944 5.57296 18.3849 5.49811 17.9938 5.79685L13.5899 9.16084C12.3182 10.1307 10.5423 10.1315 9.26987 9.16329L5.0024 5.84599C4.61384 5.54391 4.05397 5.61408 3.75198 6.00264C3.44994 6.3912 3.52007 6.95103 3.90863 7.25306L8.1794 10.5729C8.18153 10.5746 8.18372 10.5762 8.1859 10.5779C9.14044 11.3059 10.2841 11.6699 11.4281 11.6699C12.5721 11.6699 13.7163 11.3057 14.6712 10.5775Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMessage);
export default __webpack_public_path__ + "static/media/i-message.588579f3007e18e50ea221c08f4bfff0.svg";
export { ForwardRef as ReactComponent };